import { Component, OnDestroy, OnInit } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { catchError, from, map, merge, of, Subject, Subscription, switchMap } from 'rxjs';
import { LegalDocumentsService } from 'projects/borrower-app/src/app/services/legal-documents.service';
import { NavigationService } from 'projects/borrower-app/src/app/services/navigation.service';

@Component({
    selector: 'terms-and-conditions',
    templateUrl: 'terms-and-conditions.component.html',
    standalone: false
})

export class TermsAndConditionsComponent implements OnInit, OnDestroy {

  privacyStatement: string = "";

  termsOfUse: string = "";

  /** The lender's documents could not be loaded (not the same as "none configured"). */
  unavailable: boolean = false;

  private readonly _retry = new Subject<void>();

  private _subscription: Subscription | undefined;

  constructor(private readonly _legalDocuments: LegalDocumentsService,
    private readonly _navigationService: NavigationService,
    private readonly _transloco: TranslocoService) {
  }

  ngOnInit() {
    // langChanges$ emits the current language immediately, then on every EN/ES switch.
    // switchMap drops a slower, older load so its result can't overwrite the newer language.
    this._subscription = merge(this._transloco.langChanges$, this._retry)
      .pipe(switchMap(() => from(this._legalDocuments.getDocuments(this._navigationService.companyGuid)).pipe(
        map(docs => ({ docs })),
        catchError(() => of({ docs: null })),
      )))
      .subscribe(({ docs }) => {
        this.unavailable = !docs;
        this.privacyStatement = docs?.privacyPolicy ?? '';
        this.termsOfUse = docs?.termsOfUse ?? '';
      });
  }

  retry() {
    this._retry.next();
  }

  ngOnDestroy() {
    this._subscription?.unsubscribe();
  }
}
